<template>

<app-page v-if="is.loaded" :blank="page.template === 'landing'">

    <com-text v-if="!page.template" />
    <com-landing v-if="page.template === 'landing'" />

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comText from './generic/Text'
import comLanding from './generic/Landing'

export default {

	mixins: [mixinPage],
	
    components: {
		'com-text': comText,
		'com-landing': comLanding
	}

}

</script>

<style scoped>

</style>
